import { DownloadOutlined } from '@ant-design/icons'
import { Button, Card, Space, Typography } from 'antd'
import { FC, useState } from 'react'
import { Link } from 'react-router-dom'
import { downloadWordpressPlugin } from '../../../services/SmartBannerService'

const { Text } = Typography

interface Props {}

const SmartBannerDownloadWordpressPlugin: FC<Props> = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined)

  const onClick = () => {
    setIsLoading(true)
    setDownloadUrl(undefined)
    downloadWordpressPlugin()
      .then((url) => {
        setDownloadUrl(url)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <Card styles={{ body: { padding: 10 } }} className="w-full">
      <Space className="w-full space-between align-items-center" size={10}>
        <Space orientation="vertical" size={0}>
          <Text>Wordpress</Text>
          <Text type="secondary">Plugin ready to install</Text>
        </Space>

        {!downloadUrl && (
          <Button loading={isLoading} onClick={onClick}>
            Download
          </Button>
        )}
        {downloadUrl && (
          <Link
            to={downloadUrl}
            target="_blank"
            download={'plethore-smart-banner.zip'}
          >
            <Button type="primary">
              <DownloadOutlined />
            </Button>
          </Link>
        )}
      </Space>
    </Card>
  )
}

type SmartBannerDownloadWordpressPluginType = {
  DownloadWordpressPlugin: typeof SmartBannerDownloadWordpressPlugin
}

export {
  SmartBannerDownloadWordpressPlugin,
  type SmartBannerDownloadWordpressPluginType,
}
